/** One blueprint's changes from a Promote or Stop preview, in the words the confirm shows. */

import type { BlueprintImpact, ImpactStep } from './types';

const tools = (steps: ImpactStep[]): string => [...new Set(steps.map((step) => step.tool))].join(', ');
const indexes = (list: number[]): string => list.map((index) => `#${index}`).join(', ');

/** In the order an operator weighs them: serving, templates, then writes. */
export const impactLines = (impact: BlueprintImpact): string[] => {
	const lines: string[] = [];
	if (impact.enables) lines.push('Starts serving this intent');
	if (impact.templatesOn.length) lines.push(`Templates on: ${indexes(impact.templatesOn)}`);
	if (impact.templatesOff.length) lines.push(`Templates off: ${indexes(impact.templatesOff)}`);
	if (impact.stepsStartAsking.length) lines.push(`Asks a supervisor again before: ${tools(impact.stepsStartAsking)}`);
	if (impact.stepsStopAsking.length) lines.push(`Runs without asking: ${tools(impact.stepsStopAsking)}`);
	return lines;
};

/** The change that takes a permission away is the one to see first. */
export const hasRevocation = (impact: BlueprintImpact): boolean => impact.stepsStartAsking.length > 0;

/** Where an unlinked template is linked to its scenario type: the blueprint's panel in Promoted Protocols. */
export const linkTemplatesHref = (blueprintId: string): string =>
	`/training/promoted-workflows?blueprint=${encodeURIComponent(blueprintId)}`;

